import { showToastMessage } from "../../utils/toastUtils";
import {
  detectLocation,
  hasCoords,
  readStoredLocation,
  writeStoredLocation,
} from "../../utils/googleLocation";

export { hasCoords, readStoredLocation };

export const getLocation = async (options = {}) => {
  const silent = Boolean(options.silent);
  try {
    const loc = await detectLocation({ silent });
    if (!hasCoords(loc)) {
      throw new Error("Latitude and longitude were not returned");
    }
    return loc;
  } catch (err) {
    if (!silent) {
      showToastMessage(
        "warning",
        err?.userMessage || err?.message || "Unable to fetch location"
      );
    }
    throw err;
  }
};

export const getSmartLocation = async () => {
  const saved = readStoredLocation();
  const isExpired = !saved || Date.now() - (saved.timestamp || 0) > 15 * 60 * 1000;
  if (saved && !isExpired && hasCoords(saved)) return saved;
  const loc = await getLocation({ silent: true });
  return writeStoredLocation(loc);
};
